import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { setMetaMenuRoute, setMetaMenuState, clearMetaMenuTracking, setRightDrawerOpen, setActiveTab } from '../stores/actions/tabs';
import { META_MENU_ROUTES, META_MENU_STATES, TABS } from '../stores/types/tabs';

export const useMetaMenuDrawer = () => {
	const dispatch = useDispatch();

	const closeMetaMenuAndDrawer = useCallback((activeTab: TABS) => {
		dispatch(setMetaMenuRoute(META_MENU_ROUTES.NONE));
		dispatch(setMetaMenuState(META_MENU_STATES.CLOSING));
		dispatch(clearMetaMenuTracking());
		if (activeTab === TABS.GENERATE_MEDIA_CONTENT) {
			dispatch(setRightDrawerOpen(false));
			dispatch(setActiveTab(TABS.NONE));
		}
	}, [dispatch]);

	return {
		closeMetaMenuAndDrawer,
	};
};

export default useMetaMenuDrawer;